import React from 'react';
import { useState } from 'react';
import styled from 'styled-components';
import { Colors } from 'planoplan-ui-kit/core/colors';
import { IconArrowDown } from '@icons';
import { Points, textSize, common } from '@styles';

export const Accordion = ({ data = {}, isHtml = false }) => {
  const [active, setActive] = useState([]);
  const handleToggle = (index) => {
    setActive((prevActive) => {
      if (prevActive.includes(index)) {
        return prevActive.filter((i) => i !== index);
      } else {
        return [...prevActive, index];
      }
    });
  };

  return (
    <View>
      <List>
        {data
          .filter((item) => item.question.length > 0)
          .map((item, index) => (
            <ListItem
              key={index}
              className={active.includes(index) ? 'active' : 'inactive'}
              onClick={() => handleToggle(index)}>
              <Top>
                <ListTextQ id="faq_question">{item.question}</ListTextQ>
                <IconArrowDown />
              </Top>
              <Bottom onClick={() => handleToggle(index)} className={active.includes(index) ? 'show' : 'hide'}>
                {isHtml ? (
                  <ListTextA id="faq_question" dangerouslySetInnerHTML={{ __html: item.answer }} />
                ) : (
                  <ListTextA id="faq_question">{item.answer}</ListTextA>
                )}
              </Bottom>
            </ListItem>
          ))}
      </List>
    </View>
  );
};

const View = styled.div`
  margin: 0 auto;
  border-radius: 10px;
  color: ${Colors.main_dark};
`;
const List = styled.ul`
  margin: 0;
  padding: 0;
  color: ${Colors.main_dark};
  list-style: none;
`;
const ListItem = styled.li`
  cursor: pointer;
  padding: 30px 0;
  border-bottom: 1px solid #e1e1e1;
  word-wrap: break-word;
  overflow-wrap: break-word;
  width: 100%;

  svg {
    flex-shrink: 0;
    height: 20px;
    transition: transform 0.4s ease;

    @media ${Points.tablet_portrait} {
      height: 27px;
    }
  }

  &.active {
    svg {
      transform: rotate(180deg);
    }
  }

  &:first-child {
    @media ${Points.tablet_landscape} {
      padding-top: 10px;
    }
  }

  &:not(:last-child) {
    border-bottom: 1px solid #e1e1e1;
  }
`;

const Top = styled.div`
  display: flex;
  justify-content: space-between;
`;

const Bottom = styled.div`
  padding: 0;
  overflow: hidden;

  &.show {
    transition: padding 0.4s ease;
    padding-top: 20px;
    max-height: fit-content;

    @media ${Points.tablet_landscape} {
      max-width: 560px;
    }

    @media ${Points.laptop} {
      max-width: 640px;
    }

    @media ${Points.laptop_wide} {
      padding-top: 25px;
      max-width: 680px;
    }

    @media ${Points.fullhd} {
      max-width: 760px;
    }
  }
  &.hide {
    max-height: 0px;
    transition: padding 0.4s ease;
  }
`;

const ListTextQ = styled.p`
  padding-right: 34px;
  color: ${Colors.main_dark};
  ${textSize('card_header')};
  font-weight: 300;
`;

const ListTextA = styled.div`
  color: ${Colors.main_gray};
  ${textSize('article')};
  line-height: 1.3;
  font-weight: 300;

  p {
    margin-bottom: 20px;
    ${textSize('article')};
  }

  p:last-child {
    margin-bottom: 0;
  }

  ul {
    ${common('listBlog')};
  }

  ol,
  ul {
    color: ${Colors.main_gray};
    padding-left: 30px;
    margin-left: 5px;

    @media ${Points.tablet_portrait} {
      margin-left: auto;
      margin-right: auto;
    }
  }

  .list__content ul {
    margin-bottom: 0;
  }

  li {
    ${textSize('article')};
    line-height: 1.3;
    margin-bottom: 12px;
    padding-top: 3px;
    font-weight: 300;

    @media ${Points.laptop_wide} {
      margin-bottom: 12px;
    }

    & :last-child {
      margin-bottom: 20px;
    }
  }

  a:not(.bluebox-button):not(.cta-button):not(.cta-button-text) {
    ${common('a')};
    color: ${Colors.second_link};
  }

  .list {
    display: flex;
    justify-content: start;

    p {
      padding: 0;
    }
  }
`;
